import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import ModalMainWrapper from './ModalMainWrapper'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const postcardStyleImageMap = {
    Blue: '/assets/products/postcard-styles/postcardstyle_blue.png',
    'Blue Houses':
        '/assets/products/postcard-styles/postcardstyle_bluehouses.png',
    Green: '/assets/products/postcard-styles/postcardstyle_green.png',
    'Green Houses':
        '/assets/products/postcard-styles/postcardstyle_greenhouses.png',
    Pink: '/assets/products/postcard-styles/postcardstyle_pink.png',
    'Pink Houses':
        '/assets/products/postcard-styles/postcardstyle_pinkhouses.png',
    'River Reeds':
        '/assets/products/postcard-styles/postcardstyle_riverreeds.png',
    'Summer Forest':
        '/assets/products/postcard-styles/postcardstyle_summerforest.png',
    Yellow: '/assets/products/postcard-styles/postcardstyle_yellow.png',
    Sunset: '/assets/products/postcard-styles/postcardstyle_sunset.png',
    'Tri-Color Houses':
        '/assets/products/postcard-styles/postcardstyle_tricolor.png',
}

const housePattern = (bg, house) =>
    `linear-gradient(${bg}, ${bg}), url('data:image/svg+xml,${encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='46' height='40'><rect width='46' height='40' fill='${bg}'/><path d='M9 31 V19 L23 9 L37 19 V31 Z' fill='${house}'/><rect x='20' y='24' width='7' height='7' fill='${bg}'/></svg>`,
    )}')`

const triHousePattern = (() => {
    const svg =
        "<svg xmlns='http://www.w3.org/2000/svg' width='132' height='46'><rect width='132' height='46' fill='#fbf3e7'/><path d='M7 36 V22 L21 11 L35 22 V36 Z' fill='#ED5C2F'/><rect x='17' y='28' width='8' height='8' fill='#fbf3e7'/><path d='M51 36 V22 L65 11 L79 22 V36 Z' fill='#F28230'/><rect x='61' y='28' width='8' height='8' fill='#fbf3e7'/><path d='M95 36 V22 L109 11 L123 22 V36 Z' fill='#FAB331'/><rect x='105' y='28' width='8' height='8' fill='#fbf3e7'/></svg>"
    return `linear-gradient(#fbf3e7, #fbf3e7), url('data:image/svg+xml,${encodeURIComponent(
        svg,
    )}')`
})()

const reedPattern = (() => {
    const svg =
        "<svg xmlns='http://www.w3.org/2000/svg' width='46' height='48'><rect width='46' height='48' fill='#e8f2e2'/><path d='M11 48 C7 33 15 29 11 15 C8 8 11 5 12 1' stroke='#5f9152' stroke-width='2.4' fill='none' stroke-linecap='round'/><path d='M24 48 C20 33 28 29 24 15 C21 8 24 5 25 1' stroke='#7aa86a' stroke-width='2.4' fill='none' stroke-linecap='round'/><path d='M37 48 C33 33 41 29 37 15 C34 8 37 5 38 1' stroke='#4f7d46' stroke-width='2.4' fill='none' stroke-linecap='round'/></svg>"
    return `linear-gradient(#e8f2e2, #e8f2e2), url('data:image/svg+xml,${encodeURIComponent(
        svg,
    )}')`
})()

const treePattern = (() => {
    const svg =
        "<svg xmlns='http://www.w3.org/2000/svg' width='56' height='56'><path d='M4 24 L13 6 L22 24 Z' fill='#2c6238'/><path d='M30 40 L39 22 L48 40 Z' fill='#357544'/></svg>"
    return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`
})()

const postcardStyles = [
    { name: 'White', background: '#ffffff', light: true },
    {
        name: 'Tri-Color Houses',
        background: triHousePattern,
        backgroundSize: '132px 46px',
        light: true,
    },
    {
        name: 'Sunset',
        background:
            'linear-gradient(135deg,#ff9a4d 0%,#ff5e7e 52%,#a45ad6 100%)',
    },
    {
        name: 'Blue Houses',
        background: housePattern('#e7f0fb', '#3f74c9'),
        backgroundSize: '46px 40px',
        light: true,
    },
    {
        name: 'Pink Houses',
        background: housePattern('#fde9f1', '#e06090'),
        backgroundSize: '46px 40px',
        light: true,
    },
    {
        name: 'Green Houses',
        background: housePattern('#e8f5ec', '#46a86b'),
        backgroundSize: '46px 40px',
        light: true,
    },
    {
        name: 'Blue',
        background: 'linear-gradient(135deg,#3a82e0 0%,#1b4f9c 100%)',
    },
    {
        name: 'Pink',
        background: 'linear-gradient(135deg,#f573a6 0%,#d2356f 100%)',
    },
    {
        name: 'Green',
        background: 'linear-gradient(135deg,#46b877 0%,#1f7e49 100%)',
    },
    {
        name: 'Yellow',
        background: 'linear-gradient(135deg,#fde68a 0%,#facc15 100%)',
        light: true,
    },
    {
        name: 'River Reeds',
        background: reedPattern,
        backgroundSize: '46px 48px',
        light: true,
    },
    {
        name: 'Summer Forest',
        background: `${treePattern}, linear-gradient(160deg,#2f6b3f 0%,#16462a 100%)`,
        backgroundSize: '56px 56px, cover',
    },
]

const getPostcardStyle = (value) =>
    postcardStyles.find((style) => style.name === value)

export default function PostcardStyleModal({
    item,
    getValues,
    setValue,
    afterSelection,
}) {
    const skimModal = ModalStore((state) => state.skim)
    const [selected, setSelected] = useState(getValues(item.name) || '')

    useEffect(() => {
        setSelected(getValues(item.name) || '')
    }, [getValues, item.name])

    const handleConfirm = () => {
        if (!selected) return
        setValue(item.name, selected)
        afterSelection?.(selected)
        skimModal()
    }

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="4xl" spacing="normal">
                <ModalHeader title="Choose a postcard style" />
                <ModalContent spacing="normal" scroll={true}>
                    <div className="grid gap-3 sm:grid-cols-4">
                        {item.options.map((option) => {
                            const style = getPostcardStyle(option)

                            return (
                                <button
                                    key={option}
                                    type="button"
                                    onClick={() => setSelected(option)}
                                    className={classNames(
                                        selected === option
                                            ? 'border-[#F28230] shadow-[0_0_0_3px_rgba(242,130,48,0.16)]'
                                            : 'border-[#E1DACE]',
                                        'overflow-hidden rounded-xl border-[1.5px] bg-white text-left transition-all duration-150 hover:border-[#F6D9C2]',
                                    )}>
                                    <div
                                        className={classNames(
                                            style?.light
                                                ? 'text-[#1A1D23]'
                                                : 'text-white',
                                            'h-[110px] w-full',
                                        )}
                                        style={{
                                            background: postcardStyleImageMap[
                                                option
                                            ]
                                                ? `url('${postcardStyleImageMap[option]}')`
                                                : style?.background ||
                                                  '#ffffff',
                                            backgroundRepeat:
                                                postcardStyleImageMap[option]
                                                    ? 'no-repeat'
                                                    : 'repeat',
                                            backgroundPosition: 'center',
                                            backgroundSize:
                                                postcardStyleImageMap[option]
                                                    ? 'cover'
                                                    : style?.backgroundSize ||
                                                      'cover',
                                        }}
                                    />
                                    <div className="px-3 py-2 text-center text-[13px] font-semibold text-olm-black">
                                        {option}
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </ModalContent>
                <ModalFooter
                    confirmText="Select postcard style"
                    onConfirm={handleConfirm}
                />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
